export default __webpack_public_path__ + "static/media/trimming.e464f63f.svg";